import * as fromRouter from '@ngrx/router-store';
import { routerNavigatedAction } from '@ngrx/router-store';
import { createReducer, on } from '@ngrx/store';
import { setInitUrl } from './router.actions';

export interface State {
  router: fromRouter.RouterReducerState<any>;
}

export interface CustomState {
  urlCurrent: string;
  urlLast: string;
  urlEntry: string;
  navigationCount: number;
}

export const initialCustomState: CustomState = {
  urlCurrent: '',
  urlLast: '',
  urlEntry: '',
  navigationCount: 0
};

export const routerCustomReducer = createReducer(
  initialCustomState,

  on(routerNavigatedAction, (state, action) => ({
    ...state,
    urlLast: state.urlCurrent,
    urlCurrent: action.payload.event.url,
    navigationCount: state.navigationCount + 1
  })),

  on(setInitUrl, (state, action) => ({
    ...state,
    urlCurrent: action.url,
    urlEntry: action.url
  }))
);
